/** Default system settings mirroring backend SYSTEM_SETTINGS_DEFAULTS */
export const SYSTEM_SETTINGS_DEFAULTS = {
  idle_threshold_minutes: 5,
  enable_manual_logging: true,
  ai_model: 'gpt-4o-mini',
  ai_prompt_template: '',
  office_name: '',
  office_latitude: 24.8607,
  office_longitude: 67.0011,
  office_radius_km: 1000,
  daily_hours_cap: 10,
  weekly_target_hours: 40,
  daily_target_hours: 8,
  flagged_entry_threshold_hours: 8,
  timer_auto_stop_hours: 8,
  min_description_length: 50,
  entry_edit_window_hours: 24,
  under_target_threshold_percent: 75,
  annual_leave_limit: 14,
  casual_leave_limit: 12,
  medical_leave_limit: 12,
  same_day_leave_cutoff_hour: 10,
  working_days: [0, 1, 2, 3, 4],
  company_holidays: [],
  work_week_start_day: 1,
  business_hours_start: 9,
  business_hours_end: 19,
  app_timezone_offset: 5,
  min_meeting_duration_minutes: 15,
  meeting_end_buffer_minutes: 5,
  escalation_overdue_days: 3,
  max_subtask_hours: 16,
  max_file_upload_mb: 10,
  currency_code: 'USD',
  // Weekly Hours Enforcement
  weekly_hours_enforcement_enabled: true,
  weekly_hours_dry_run_enabled: false,
  weekly_hours_test_recipient_emails: [],
  member_pace_factor: 0.75,
  weekly_report_recipient_user_id: null,
  notify_team_lead_on_final_reminder: false,
  member_reminder_days: [1, 3, 4],
  member_reminder_hour: 10,
  member_reminder_minute: 0,
  member_reminder_levels: ['gentle', 'warning', 'final'],
  member_reminder_departments: [],
  member_reminder_excluded_user_ids: [],
  hr_report_departments: [],
  hr_report_excluded_user_ids: [],
  lead_summary_day: 0,
  lead_summary_hour: 9,
  lead_summary_minute: 0,
  hr_report_day: 0,
  hr_report_hour: 9,
  hr_report_minute: 5,
};

export const DAY_LABELS = [
  { value: 0, label: 'Mon' },
  { value: 1, label: 'Tue' },
  { value: 2, label: 'Wed' },
  { value: 3, label: 'Thu' },
  { value: 4, label: 'Fri' },
  { value: 5, label: 'Sat' },
  { value: 6, label: 'Sun' },
];

/** Merge API response with defaults for safe reads in components */
export function mergeSystemSettings(data) {
  if (!data) return { ...SYSTEM_SETTINGS_DEFAULTS };
  return { ...SYSTEM_SETTINGS_DEFAULTS, ...data };
}
